export default "__VITE_ASSET__BDlFhDBm__"